<script>
  import { onDestroy } from "svelte";
  import { EmptyButton } from "@saztrek/firefly";
  // import { navigateTo } from "svelte-router-spa";

  import LoadingIndicator from "../../components/LargeLoadingIndicator.svelte";

  import NodeTable from "./NodeTableSummary.svelte";

  import { PS3Db } from "../../../middleware/database/ps3";
  import { FirebaseResults } from "../../../middleware/database";

  import { currentUser } from "../../../stores/current_user";

  export let currentRoute;
  export let params;

  let loading = true;

  /* svelte router force feeds these parameters (see above).
     Console warns if we don't do the exports.
     Svelte warns if they are unused, therefore putting them down here, in case code needs it.
  */
  // eslint-disable-next-line no-unused-vars
  const paramsFromRouter = params;
  // eslint-disable-next-line no-unused-vars
  const currentRouteFromRouter = currentRoute;

  let ps3RawSheetsDB;
  let unsubscribeQuery;
  let summary;

  const categories = [
    {
      code: "COFFEEMIXES",
      name: "Coffee Mixes"
    },
    {
      code: "SOLUBLES",
      name: "Solubles"
    },
    {
      code: "CREAMER",
      name: "Creamers"
    },
    {
      code: "CHOCOLATEBEVERAGE",
      name: "Chocolate Beverage"
    }
    // {
    //   code: "POWDEREDMILK",
    //   name: "Powdered Milk"
    // },
    // {
    //   code: "TESTC7",
    //   name: "Test Category 7"
    // }
  ];

  // const categoryMap = {};

  const buildCategoryPercentage = (filteredSheets) => {
    let sumOfTotalCategoryLengths = 0;
    let sumOfCompetitorCategoryLengths = 0;
    let universeLength = 0;

    for (let i = 0; i < filteredSheets.length; i += 1) {
      if (!filteredSheets[i].isCompetitor) {
        // sumOfTotalCategoryLengths +=
        //   filteredSheets[i].bayReport[0].layerReport.totalCategoryLength;
        sumOfTotalCategoryLengths += parseInt(filteredSheets[i].skuLength, 10);
      } else {
        // sumOfCompetitorCategoryLengths +=
        //   filteredSheets[i].bayReport[0].layerReport.totalCategoryLength;
        sumOfCompetitorCategoryLengths += parseInt(
          filteredSheets[i].skuLength,
          10
        );
      }
      // universeLength += parseInt(filteredSheets[i].universeLength, 10);
      universeLength += parseInt(filteredSheets[i].skuLength, 10);
    }

    const percentSOSRaw = (
      (sumOfTotalCategoryLengths / universeLength) *
      100
    ).toFixed(2);

    const percentSOSCompetitorRaw = (
      (sumOfCompetitorCategoryLengths / universeLength) *
      100
    ).toFixed(2);

    return {
      universeLength,
      sumOfTotalCategoryLengths,
      // eslint-disable-next-line no-restricted-globals
      percentSOS: !isNaN(percentSOSRaw) ? `${percentSOSRaw}%` : "N/A",
      sumOfCompetitorCategoryLengths,
      // eslint-disable-next-line no-restricted-globals
      percentSOSCompetitor: !isNaN(percentSOSCompetitorRaw)
        ? `${percentSOSCompetitorRaw}%`
        : "N/A"
    };
  };

  let flattenedPublishedSheets = [];

  const buildSummary = (dataArray) => {
    const sheets = dataArray.map((data) => {
      const { publishedSheet, universeLength } = data;
      return {
        publishedSheet,
        universeLength
      };
    });

    sheets.forEach((sheet) => {
      flattenedPublishedSheets = [
        ...flattenedPublishedSheets,
        ...sheet.publishedSheet
      ];
    });

    let allSKUs = [];

    flattenedPublishedSheets.forEach((sheet) => {
      allSKUs = [...allSKUs, sheet.bayReport[0].layerReport.skus];
    });

    console.log(allSKUs.flat());
    allSKUs = allSKUs.flat();

    return categories.map((category) => {
      const { code, name } = category;
      // const filteredSheets = flattenedPublishedSheets.filter(
      //   sheet => sheet.bayReport[0].layerReport.category === code
      // );

      const filteredSheets = allSKUs.filter((sku) => sku.categoryCode === code);

      const categoryPercentage = buildCategoryPercentage(filteredSheets);
      // const publishedSheets = sheets.find(sheet => )

      return {
        name,
        ...categoryPercentage
      };
    });
  };

  const fetchSheets = (tenantId) => {
    if (unsubscribeQuery) {
      unsubscribeQuery();
    }

    if (!tenantId) return;
    if (!ps3RawSheetsDB) {
      ps3RawSheetsDB = PS3Db(tenantId);
    }
    unsubscribeQuery = ps3RawSheetsDB.findAllPublished().onSnapshot((docs) => {
      summary = buildSummary(FirebaseResults.map(docs));
      console.log(summary);
      loading = false;
    });
  };

  $: fetchSheets($currentUser.tenantId);

  onDestroy(() => {
    unsubscribeQuery();
  });
</script>

<div class="flex flex-col items-center pt-8">

  <div class="pt-4 w-full">
    <div class="w-full">

      <div class="m-0 text-base flex flex-row items-center justify-center pb-4">
        <div>
          <EmptyButton icon="arrowLeft" text="" size="tiny" />
        </div>
        <div class="w-64 text-center">{'December 2020'}</div>
        <div>
          <EmptyButton icon="arrowRight" text="" size="tiny" />
        </div>

      </div>

      <div class="w-full px-10">
        <div class="w-full rounded shadow px-10" style="min-height: 520px">
          {#if loading}
            <LoadingIndicator />
          {:else}
            <div class="pb-2">
              <NodeTable edges={summary} />
            </div>
          {/if}
        </div>
      </div>
      <div class="pt-2 px-10">
        <!-- disabled={!result.data.accounts.pageInfo.hasPreviousPage}-->
        <!--  <Button
            icon="arrowLeft"
            color="primary"
            on:click={() => {
              goToPreviousPage(result.data.accounts.pageInfo.startCursor);
            }} /> -->
        <!-- disabled={!result.data.accounts.pageInfo.hasNextPage} -->
        <!--  <Button
            icon="arrowRight"
            color="primary"
            on:click={() => {
              goToNextPage(result.data.accounts.pageInfo.endCursor);
            }} /> -->

      </div>

    </div>
  </div>
</div>
